import React, { forwardRef } from 'react'
import PoRequest from '../../PoRequest'

const IndividualInvoice = forwardRef((props,ref) => {
  return (
    <div><PoRequest {...props} creationMode={1} ref={ref}/></div>
  )
})

export default IndividualInvoice